// src/routes/AuthGate.jsx
import React from "react";
import { Flex, Loader } from "@aws-amplify/ui-react";
import { useAuthenticator } from "@aws-amplify/ui-react";

export default function AuthGate({ children }) {
  const { authStatus } = useAuthenticator((ctx) => [ctx.authStatus]);

  if (authStatus === "configuring") {
    return (
      <Flex justifyContent="center" padding="2rem">
        <Loader />
      </Flex>
    );
  }

  return children;
}
